<div class="car-page">

  <!-- ── Progress bar ──────────────────────────────── -->
  <div class="car-progress-bar" *ngIf="!enregistrementTerminer">
    <div class="car-progress-bar__inner"></div>
  </div>

  <!-- ── Page header ──────────────────────────────── -->
  <header class="car-page__header">
    <h1 class="car-page__title">
      <span class="car-page__title-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      </span>
      Sections Spéciaux
    </h1>
    <p class="car-page__subtitle">Gérer les Sections Spéciaux.</p>
  </header>

  <form #f="ngForm">
    <div class="car-grid">

      <!-- ══ LEFT PANEL — Configuration du Groupe ══ -->
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
            </span>
            Configuration du Section
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="ajouterSelection()" [disabled]="disabled"
              class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Ajouter
            </button>
            <button type="button" (click)="modifierSelection()" class="car-btn car-btn--success car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Modifier
            </button>
            <button type="button" (click)="deleteSelection()" [disabled]="disabled"
              class="car-btn car-btn--danger car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6M14 11v6" />
                <path d="M9 6V4h6v2" />
              </svg>
              Supprimer
            </button>
          </div>
        </div>

        <div class="car-panel__body">

          <!-- Form row: image + article search + category + ordre -->
          <div class="grp-form-strip relative">

            <!-- Image upload -->
            <div class="grp-img-upload">
              <div class="grp-img-upload__preview" (click)="importer('input_30_30')">
                <img id="30_30"
                  [src]="lastEvent == 'upload' ? imageCategorieSrc : generalService.base_url + 'images/' + imageCategorieSrc"
                  alt="Preview" />
                <div class="grp-img-upload__overlay">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                    <circle cx="12" cy="13" r="4" />
                  </svg>
                </div>
              </div>
              <input id="input_30_30" type="file" style="display:none" (change)="onChangeImagefile2($event)" />
              <button type="button" (click)="supprimerImage()" class="grp-img-upload__clear">Effacer</button>
            </div>



            <!-- Category dropdown -->
            <div class="car-field car-field--grow">
              <label class="car-label">Section</label>
              <input type="text" name="section" [(ngModel)]="section.ecSection_Label" class="car-input">
            </div>

            <!-- Ordre -->
            <div class="car-field car-field--ordre">
              <label class="car-label">Ordre</label>
              <input class="car-input" type="number" name="groupe_Ordre" #groupe_Ordre="ngModel" required
                [(ngModel)]="section.ecSection_Ordre" placeholder="0" />
            </div>

            <span *ngIf="section.ecSection_Code != null" (click)="initSection()"
              class="absolute top-2 right-2 text-gray-500 cursor-pointer">
              <svg _ngcontent-otq-c328="" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" class="w-4 h-4">
                <path _ngcontent-otq-c328="" stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12">
                </path>
              </svg>
            </span>

          </div>

          <!-- Search filter -->
          <div class="car-toolbar">
            <div class="car-search">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <!-- (keyup)="applyFilter($event.target.value)" -->
              <input class="car-search__input" type="text" placeholder="Filtrer la table…" />
            </div>
          </div>

          <!-- Groupes table — pure HTML, zero Material -->
          <div class="car-table-wrap">
            <table class="car-table">
              <thead>
                <tr>
                  <th style="width:64px">Image</th>
                  <th style="width:64px">Code</th>
                  <th>Texte</th>
                  <th style="width:70px">Ordre</th>

                  <th style="width:90px" class="center">afficher</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let element of allSelections; let i = index" (click)="selectRowSelection(element)"
                  [class.selected]="element === rowSelection">
                  <td>
                    <div class="grp-thumb">
                      <img *ngIf="element.ecSection_Code"
                        [src]="generalService.base_url + 'images/' + element.ecSection_Icone" alt="" />
                    </div>
                  </td>
                  <td class="code">{{ element.ecSection_Code }}</td>
                  <td class="bold">{{ element.ecSection_Label | textPipe : 'capitalize' }}</td>
                  <td>{{ element.ecSection_Ordre }}</td>

                  <td class="center">
                    <label class="car-toggle car-toggle--sm">
                      <input type="checkbox" [(ngModel)]="checkedStatus[i]" [name]="'checkPos' + element.ecSection_Code"
                        (change)="toggleSelectionDisplay($event, element)" />
                      <span class="car-toggle__track"></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

      <!-- ══ RIGHT PANEL — Menu du Groupe ══ -->
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
              </svg>
            </span>
            Menu du Groupe
          </div>
          <div class="car-panel__header-actions">
            <!-- <button type="button" (click)="ajouterMenue(f)" [disabled]="disabled"
              class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              Ajouter menu
            </button> -->
          </div>
        </div>

        <div class="car-panel__body">

          <!-- Association Articles sub-section -->
          <div class="grp-sub-section">
            <div class="grp-sub-section__title">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path
                  d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                <line x1="12" y1="22.08" x2="12" y2="12" />
              </svg>
              Association Articles
            </div>

            <div class="car-form-row">
              <div class="car-field car-field--grow">
                <app-recherche recherche="ecarticleauto2" displayColumn="Art_Des" name="articleName"
                  (ChampEnter)="onArticleSelected($event)" placeholder="Sélectionner l'article…"
                  [(ngModel)]="parentVal"></app-recherche>
              </div>
              <div class="car-field car-field--ordre">
                <label class="car-label">Ordre</label>
                <input class="car-input" name="Ordre_Art" #menueTab_Label="ngModel" [(ngModel)]="ordreArticle"
                  placeholder="0" />
              </div>
            </div>

            <div class="car-toolbar car-toolbar--end">
              <button type="button" (click)="ajouterArticle()" class="car-btn car-btn--success car-btn--sm">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                  <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Lier Article
              </button>

            </div>
          </div>

          <!-- Menu table with expandable rows -->
          <div class="car-table-wrap" *ngIf="showArticleList">
            <table class="car-table">
              <thead>
                <tr>

                  <th style="width:64px">Code</th>
                  <th>Texte</th>
                  <th style="width:80px">Ordre</th>
                  <th style="width:80px">Afficher</th>

                  <th style="width:72px" class="center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let element of associatedProducts ; let i = index">
                  <!-- Main row -->
                  <tr [id]="'trTable' + element.Art_Code"
                    (click)="selectRowArticle($event, element, 'trTable' + element.Art_Code)"
                    [class.selected]="element === selecedArticle">


                    <td class="code">{{ element.Art_Code }}</td>
                    <td>
                      <input class="car-input car-input--ghost" [name]="'menueTab_Label' + element.Art_Code" required
                        readonly [(ngModel)]="element.label" />
                    </td>
                    <td>
                      <input class="car-input car-input--ghost car-input--order" type="number"
                        [name]="'menueTab_Labels' + element.ecSectionArt_Ordre"
                        [(ngModel)]="element.ecSectionArt_Ordre" />
                    </td>
                    <td class="center">
                      <label class="car-toggle car-toggle--sm">
                        <input type="checkbox" [checked]="element.ecSectionArt_Visibility"
                          [name]="'checkPosArt' + element.ecSectionArt_Code" (change)="toggleSelectionArtDisplay(i)" />
                        <span class="car-toggle__track"></span>
                      </label>
                    </td>
                    <td class="center">
                      <div class="grp-row-actions">
                        <button type="button" class="grp-icon-btn grp-icon-btn--amber" title="Modifier"
                          (click)="modifierAssosiatedProduct(element , i)">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                          </svg>
                        </button>
                        <button type="button" class="grp-icon-btn grp-icon-btn--rose" title="Supprimer"
                          (click)="supprimerArticleFromSelection(i)">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>


                </ng-container>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </div>
  </form>

  <!-- ── Bannières section (BIGDAR only) ──────────── -->

</div>